<template>
    <router-view></router-view>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ivew/window.vue